/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DressingsListAliases {
  BUTTON_ADD_WOUNDS_DRESSINGS = 'button-add-wounds-dressings',
  CARD_CONTAINER_BODY = 'card-container-body',
  CARD_CONTAINER_DRESSINGS = 'card-container-dressings',
  CARD_CONTAINER_ZONE_0 = 'card-container-zone-0',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_DRESSINGS = 'deck-dressings',
  FETCH_DRESSINGS = 'fetch-dressings',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_WOUND_DESCRIPTION = 'field-wound-description',
  FIELD_WOUND_SCORE = 'field-wound-score',
  GLOBAL_ACTIONS_DRESSINGS_LIST = 'global-actions-dressings-list',
  ICON_MAPPER = 'icon-mapper',
  ICON_SWITCHER_DRESSINGS = 'icon-switcher-dressings',
  LAYOUT_DRESSINGS_LIST = 'layout-dressings-list',
  MAIN_CARD_CONTAINER_ZONE = 'main-card-container-zone',
  MAIN_LEGENDS = 'main-legends',
  MAPPER_DRESSINGS = 'mapper-dressings',
  PANEL_ACTIONS_DRESSINGS_LIST = 'panel-actions-dressings-list',
  SCORE_CARD_CONTAINER_ZONE = 'score-card-container-zone',
  STATUS_CARD_CONTAINER_ZONE = 'status-card-container-zone',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_WOUND_DESCRIPTION = 'text-wound-description',
  TEXT_WOUND_SCORE = 'text-wound-score',
}
export { DressingsListAliases };
